// Shared kiln helpers (UI-only) to keep kiln changes additive and local.
export const CLAY_FIRE_TYPES = ["earthenware", "mid-fire", "stoneware", "other"];

const LABELS = {
  earthenware: "Earthenware",
  "mid-fire": "Mid-fire",
  stoneware: "Stoneware",
  other: "Other",
};

const NORMALISE_MAP = [
  { test: (s) => s.includes("earth"), value: "earthenware" },
  { test: (s) => s.includes("low-fire"), value: "earthenware" },
  { test: (s) => s.includes("low fire"), value: "earthenware" },
  { test: (s) => s.includes("mid"), value: "mid-fire" },
  { test: (s) => s.includes("cone 5") || s.includes("cone5"), value: "mid-fire" },
  { test: (s) => s.includes("cone 6") || s.includes("cone6"), value: "mid-fire" },
  { test: (s) => s.includes("porcelain"), value: "mid-fire" },
  { test: (s) => s.includes("stone"), value: "stoneware" },
  { test: (s) => s.includes("cone 10") || s.includes("cone10"), value: "stoneware" },
];

export function normalizeClayFireType(raw) {
  const s = (raw || "").toString().trim().toLowerCase();
  if (!s) return null;
  if (CLAY_FIRE_TYPES.includes(s)) return s;
  const mapped = NORMALISE_MAP.find((m) => m.test(s));
  if (mapped) return mapped.value;
  return null;
}

export function inferClayFireType(entry) {
  if (!entry) return null;
  const direct =
    normalizeClayFireType(
      entry.clayFireType ||
        entry.clayType ||
        entry.clay ||
        entry.clayBody ||
        entry.bodyType ||
        entry.body ||
        entry.material
    ) || null;
  if (direct) return direct;

  const notes = [
    entry.notes,
    entry.title,
    entry.description,
    entry.type,
    entry.status,
    entry.tags?.join?.(" "),
  ]
    .filter(Boolean)
    .join(" ")
    .trim();

  return normalizeClayFireType(notes) || null;
}

export function clayFireTypeLabel(type) {
  return LABELS[normalizeClayFireType(type) || type] || "Unknown";
}

export function matchesClayFilter(entry, active) {
  if (!active || active === "all") return true;
  const clay = inferClayFireType(entry) || "other";
  return clay === active;
}

export function clayFireTypeTagClass(type) {
  const clay = normalizeClayFireType(type) || "other";
  const base = "px-2 py-0.5 rounded-full text-[11px] border inline-flex items-center gap-1";
  const palette = {
    earthenware: "bg-amber-500/10 text-amber-400 border-amber-400/40",
    "mid-fire": "bg-orange-500/10 text-orange-300 border-orange-400/40",
    stoneware: "bg-sky-500/10 text-sky-300 border-sky-400/40",
    other: "bg-zinc-500/10 text-zinc-200 border-zinc-400/40",
  };
  return `${base} ${palette[clay] || palette.other}`;
}

export const clayFilterOptions = [
  { value: "all", label: "All" },
  { value: "earthenware", label: LABELS.earthenware },
  { value: "mid-fire", label: LABELS["mid-fire"] },
  { value: "stoneware", label: LABELS.stoneware },
  { value: "other", label: LABELS.other },
];
